<template lang="html">
  <img
    class="brand-logo"
    src="@/assets/logo.svg"
    alt="Omroep West"
    width="260"
  />
  <h1 class="title">Waarom gebruik je de Omroep West app nog niet</h1>
  <textarea
    v-model="reason"
    class="form-control reason-field"
    rows="5"
    placeholder="Typ hier je antwoord"
  ></textarea>
  <div class="downloads">
    <a
      href="https://apps.apple.com/us/app/omroep-west/id421363255"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        src="@/assets/AppleStore.png"
        alt="Download op de App Store"
        class="app-badge"
      />
    </a>
    <a
      href="https://play.google.com/store/apps/details?id=nl.omroepwest.android&referrer=utm_source%3Domroepwest.nl%26utm_campaign%3DApp-pagina"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        src="@/assets/GooglePlay.png"
        alt="Op Google Play"
        class="app-badge"
      />
    </a>
  </div>
  <div class="d-grid gap-2 mt-3">
    <button
      type="button"
      class="btn btn-secondary text-light btn-lg rounded-0"
      @click="setQuestionFour()"
      :disabled="!reason || !reason.trim()"
    >
      <span>Volgende</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "QuestionFourScreen",
  data: () => ({
    reason: "",
  }),
  methods: {
    setQuestionFour() {
      const answer = this.reason.trim();
      this.$store.commit("setQuestionTwo", answer);
      this.$store.commit("setQuestionThree", "");
      this.$store.commit("setQuestionFour", "");
      this.$store.commit("setQuestionGdpr", null);
      this.$store.commit("setSavedData", null);
    },
  },
};
</script>

<style lang="css" scoped>
h1 {
  font-size: 1.6rem;
  color: #ffffff;
  margin-bottom: 20px;
  font-weight: 700;
}
.brand-logo {
  margin-bottom: 20px;
}
.reason-field {
  border-radius: 4px;
  border: none;
  font-size: 1rem;
  margin-bottom: 16px;
  padding: 12px;
  font-family: inherit;
}
.downloads {
  display: grid;
  gap: 12px;
  margin-bottom: 20px;
  justify-items: center;
}
.downloads a {
  display: block;
  text-decoration: none;
}
.app-badge {
  max-width: 100%;
  height: auto;
  width: 220px;
  transition: opacity 0.2s ease;
}
.downloads a:hover .app-badge {
  opacity: 0.9;
}
button {
  background-color: #ffffff !important;
  color: #db011c !important;
  border: none !important;
  min-height: 56px;
  font-weight: 600;
}
button:hover {
  background-color: #f0f0f0 !important;
}

@media (min-width: 768px) {
  h1 {
    font-size: 1.9rem;
  }

  .reason-field {
    font-size: 1.1rem;
    padding: 14px;
  }

  .app-badge {
    width: 240px;
  }
}
</style>
